import { render, staticRenderFns } from "./ownerTransfer.vue?vue&type=template&id=5c8d032f&scoped=true"
import script from "./ownerTransfer.vue?vue&type=script&lang=js"
export * from "./ownerTransfer.vue?vue&type=script&lang=js"
import style0 from "./ownerTransfer.vue?vue&type=style&index=0&id=5c8d032f&prod&style=true&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8d032f",
  null
  
)

export default component.exports